import {
  type Components,
  type SxProps,
  type Theme,
} from "@mui/material/styles";

export const select: Components<Theme>["MuiSelect"] = {
  defaultProps: {
    variant: "outlined",
    size: "small",
  },
};

export const brandedDarkSelectSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root, &.MuiOutlinedInput-root": {
    backgroundColor: (t) => t.palette.primary[600],
    color: "common.white",
    borderRadius: 0.75,
  },
  "& .MuiOutlinedInput-notchedOutline, &.MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline":
    {
      borderColor: "divider",
    },
  "&:hover .MuiOutlinedInput-notchedOutline, &.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline, &.Mui-focused .MuiOutlinedInput-notchedOutline":
    {
      borderColor: (t) => t.palette.common.white,
    },
  "& .MuiSelect-icon, & .MuiInputAdornment-root, & .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator":
    {
      color: "common.white",
    },
  "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
    color: "common.white",
    caretColor: "common.white",
    backgroundColor: "transparent",
  },
  "& .MuiSelect-select": {
    padding: "8px 12px",
  },
};
